function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function NailPolish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12",
    height: "16",
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.8573 9.7059H.4287v-.8824c0-.4873.3838-.8823.8571-.8823h4.2858c.4734 0 .8571.395.8571.8823v.8824h-.4286V15H.8573V9.7059Z",
    fill: "#BFF6F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3716 9.1765v5.2941h4.1143V9.1765h.4285v-.353c0-.195-.1535-.353-.3428-.353H1.2858c-.1893 0-.3428.158-.3428.353v.353h.4286ZM6 9.7059h.4286v-.8824c0-.4873-.3837-.8823-.8571-.8823H1.2858c-.4733 0-.857.395-.857.8823v.8824h.4285V15H6V9.7059Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2856 6.6176c0-.4873.3838-.8823.8572-.8823h2.5714c.4734 0 .8572.395.8572.8823v1.7648H1.2856V6.6176Z",
    fill: "#BFF6F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7142 6.2647H2.1428c-.1894 0-.3429.158-.3429.353v1.2352h3.2572V6.6176c0-.1949-.1535-.3529-.3429-.3529Zm-2.5714-.5294c-.4734 0-.8572.395-.8572.8823v1.7648h4.2858V6.6176c0-.4873-.3838-.8823-.8572-.8823H2.1428Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7144.6228c0-.344.2708-.6228.605-.6228 1.5594 0 2.8235 1.3013 2.8235 2.9066v3.2699H1.7144V.6228Z",
    fill: "#FFCCEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2286 5.647h2.4V2.9067c0-1.3129-1.0338-2.3772-2.3092-2.3772a.0921.0921 0 0 0-.0908.0934v5.0243ZM2.3194 0c-.3342 0-.605.2789-.605.6228v5.5537h3.4285v-3.27C5.143 1.3014 3.8788 0 2.3194 0Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4626 1.9929c-.432-.5148-.5769-1.1307-.5769-1.5517H2.4c0 .3142.1124.8013.4518 1.2056.3313.3947.8997.7355 1.8625.7355v.5295c-1.0943 0-1.8116-.3945-2.2517-.9189Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8708 8.6772c.245-.9414 1.185-1.5 2.0995-1.2478l2.4838.6851c.9145.2523 1.4573 1.22 1.2122 2.1613l-1.2201 4.6876c-.1225.4707-.5925.75-1.0498.6239l-4.1397-1.1418c-.4573-.1262-.7286-.61-.606-1.0807l1.22-4.6876Z",
    fill: "#FFCCEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.321 8.6259-2.4838-.6851c-.6401-.1766-1.2981.2145-1.4697.8734l-1.2201 4.6876c-.049.1883.0595.3818.2424.4323l4.1397 1.1418c.1829.0505.3709-.0612.42-.2495l1.2201-4.6876c.1715-.659-.2084-1.3363-.8486-1.513ZM6.9703 7.4294c-.9145-.2523-1.8545.3064-2.0995 1.2478l-1.2202 4.6876c-.1225.4707.1489.9545.6061 1.0807l4.1397 1.1418c.4573.1261.9273-.1532 1.0498-.6239l1.2201-4.6876c.2451-.9414-.2977-1.909-1.2122-2.1613l-2.4838-.6851Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9236 3.5069c.1508-.4319.598-.6727 1.0285-.554l.9602.2649c.4306.1188.7009.5575.6217 1.009l-.6114 3.4854c-.0892.508-.581.829-1.0654.6954l-1.5121-.417c-.4844-.1337-.7544-.6649-.5848-1.1507l1.1633-3.333Z",
    fill: "#BFF6F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.7792 3.7292-.9602-.2649c-.1722-.0475-.351.0488-.4114.2216l-1.1634 3.333c-.0678.1943.0402.4068.234.4603l1.5121.417c.1938.0535.3905-.075.4262-.2781l.6114-3.4853c.0316-.1806-.0765-.3561-.2487-.4036Zm-.827-.7763c-.4307-.1187-.8778.1221-1.0286.554l-1.1633 3.333c-.1696.4858.1004 1.017.5848 1.1506l1.5121.4171c.4844.1336.9762-.1875 1.0654-.6954l.6114-3.4853c.0792-.4516-.1911-.8903-.6217-1.0091l-.9602-.2649Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.8906 9.8713 3.3118.9135-.4437 1.7046-3.3118-.9135.4437-1.7046Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.5725 11.1592-2.3182-.6395-.1775.6819 2.3182.6394.1775-.6818ZM5.8906 9.8713 5.447 11.576l3.3118.9135.4437-1.7046-3.3118-.9135Z",
    fill: "#528693"
  }));
}

export default NailPolish;